import type { FC } from "react";

import { cn } from "@/ui/lib";
import {
  ITEM_TITLE_DEFAULTS,
  ITEM_TITLE_SIZE_PROP_MAP,
  TItemTitleProps,
} from "@/ui/components/data-display/Item/Item.config";
import { TextSubtitle } from "../../typography/TextSubtitle";

export const ItemTitle: FC<TItemTitleProps> = (
  {
    className,
    size = ITEM_TITLE_DEFAULTS.size,
    tag = ITEM_TITLE_DEFAULTS.tag,
    children,
  },
) => (
  <TextSubtitle
    tag={tag}
    size={ITEM_TITLE_SIZE_PROP_MAP[size]}
    className={cn(className)}
  >
    { children }
  </TextSubtitle>
);

ItemTitle.displayName = "ItemTitle";
